module.exports = __webpack_public_path__ + "img/Achievement.8c786c05.svg";